import React from 'react'
import { slide as BurgerMenu } from 'react-burger-menu'
import { PropTypes } from 'prop-types'
import { Button } from '@sainsburys-tech/fable'
import cancelIcon from '../../assets/cancel.svg'
import { isTokenExpired, getRememberMe, setRememberMe } from '../../utils/storage'
import userManager from '../../utils/identity'
import { sendMessage } from '../../utils/appHelper'

const styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '0',
    height: '0',
    left: '0',
    top: '0',
    background: 'red'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
    left: window.innerWidth > 720 ? '18px' : '12px',
    top: window.innerWidth > 720 ? '18px' : '10px'
  },
  bmCross: {
    background: 'white'
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%'
  },
  bmMenu: {
    background: 'white',
    overflow: 'hidden',
    width: 'fit-content',
    minWidth: '300px'
  }
}

class Menu extends React.Component {
  menuStateChanged = (state) => {
    const { toggleMenu } = this.props

    isTokenExpired()

    if (!state.isOpen) {
      toggleMenu(false)
    }
  }

  logout = () => {
    setRememberMe(false)
    sendMessage('logout', 'logout')
    userManager.signoutRedirect()
  }

  tokenExpired = () => {
    const remember = getRememberMe()

    if (remember === 'true') {
      return false
    }

    return isTokenExpired()
  }

  handleResetPassword = () => {
    this.props.toggleMenu(false)
    this.props.history.push('/changepassword')
  }

  renderLinks = () => {
    const { user } = this.props

    const tokenExpired = this.tokenExpired()

    if (!tokenExpired && user) {
      // eslint-disable-next-line
      return (
        <React.Fragment>
          <div className="dsib-menu-section">
            <div className="dsib-menu-user">
              <b className="dsib-menu-userName">{user.fullName}</b>
              <p className="dsib-menu-userId">{user.username}</p>
            </div>
            <button type="button" className="custom-text-button dsib-custom-text-button" onClick={this.handleResetPassword}>Change password</button>
            <button id="button" className="custom-text-button dsib-custom-text-button">Cookie Settings</button>
          </div>

          <div className="dsib-menu-divider" />

          <div className="dsib-menu-section">
            <Button className="logoutbutton" onClick={this.logout} variant="primary">Log Out</Button>
          </div>
        </React.Fragment>
      )
    }
    if (tokenExpired || !user) {
      return (
        <React.Fragment>
          <div className="dsib-menu-section dsib-menu-section--compact">
            <button id="ot-sdk-btn" className="ot-sdk-show-settings dsib-custom-text-button">Cookie Settings</button>
            <a className="dsib-menu-link" href="/Login">Log in</a>
          </div>
          <div className="dsib-menu-divider dsib-menu-divider--flush" />
        </React.Fragment>
      )
    }
  }

  render() {
    const { isOpen, pageWrapId, outerContainerId } = this.props

    return (
      <div>
        <BurgerMenu
          isOpen={isOpen}
          styles={styles}
          onStateChange={this.menuStateChanged}
          customBurgerIcon={false}
          customCrossIcon={<img src={cancelIcon} alt="close icon" />}
          pageWrapId={pageWrapId}
          outerContainerId={outerContainerId}
        >
          <div className="dsib-menu-titleWrap">
            <span className="c-header dsib-menu-title">Sign-in book</span>
          </div>

          {this.renderLinks()}

        </BurgerMenu>
      </div>
    )
  }
}

Menu.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string
  }),
  isOpen: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  pageWrapId: PropTypes.string,
  outerContainerId: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
}

Menu.defaultProps = {
  user: {
    username: null
  },
  pageWrapId: undefined,
  outerContainerId: undefined,
}

export default Menu
